import { render } from "./ScreenLoader.vue?vue&type=template&id=48002218"
import script from "./ScreenLoader.vue?vue&type=script&lang=js"
export * from "./ScreenLoader.vue?vue&type=script&lang=js"

import "./ScreenLoader.vue?vue&type=style&index=0&id=48002218&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__